import { __assign, __rest } from "tslib";
import React from 'react';
import { RicosViewer } from 'ricos-viewer';
import { runStrategies, extractPluginsConfig, fetchLinkPreviewData, themeStrategy, } from '@wix/ricos-common';
import { merge } from 'lodash';
import './styles.global.css';
var WixRicosViewer = function (props) {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    var wixRicosVersion = require('../../package.json').version;
    var children = props.children, biSettings = props.biSettings, instance = props.instance, plugins = props.plugins, theme = props.theme, wixExperiments = props.wixExperiments, allowLinkPreviewPopover = props.allowLinkPreviewPopover, httpClient = props.httpClient, rest = __rest(props, ["children", "biSettings", "instance", "plugins", "theme", "wixExperiments", "allowLinkPreviewPopover", "httpClient"]);
    var strategyProps = runStrategies({
        plugins: plugins,
        instance: instance,
        biSettings: biSettings,
        experiments: wixExperiments,
        wixRicosVersion: wixRicosVersion,
        httpClient: httpClient,
    });
    var _rcProps = merge(strategyProps, extractPluginsConfig(plugins, strategyProps.helpers));
    return (React.createElement(RicosViewer, __assign({ _rcProps: _rcProps, experiments: _rcProps.experiments, plugins: plugins, theme: themeStrategy(theme) }, (allowLinkPreviewPopover && {
        linkPreviewPopoverFetchData: fetchLinkPreviewData(instance),
    }), rest), children));
};
export default WixRicosViewer;
//# sourceMappingURL=WixRicosViewer.js.map